
import { Switch } from "@/components/ui/switch";
import { Eye, EyeOff } from "lucide-react";

interface VisibilityToggleProps {
  id: string;
  isVisible: boolean;
  onToggle: () => void;
}

export const VisibilityToggle = ({ id, isVisible, onToggle }: VisibilityToggleProps) => {
  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={isVisible}
        onCheckedChange={onToggle}
        id={`visibility-${id}`}
      />
      <label 
        htmlFor={`visibility-${id}`}
        className="text-sm text-gray-600 cursor-pointer flex items-center"
      >
        {isVisible ? (
          <>
            <Eye className="h-4 w-4 mr-1" />
            <span>Visible</span>
          </>
        ) : (
          <>
            <EyeOff className="h-4 w-4 mr-1" />
            <span>Hidden</span>
          </>
        )}
      </label>
    </div>
  );
};
